export const generateQueryParams = (query) => {
  let skip = 0;
  let pagesize = 10;

  if (query?.skip) {
    skip = query.skip;
  }
  if (query?.pagesize) {
    pagesize = query.pagesize;
  }

  return `?skip=${skip}&pagesize=${pagesize}`;
};
